import {
	BaleStorageClient,
	BaleStorageDto,
	IBaleStorageDto,
	IUnitDetailsAdditionalRequirementsDto,
	IUnitDetailsAdminDto,
	IUnitDetailsCountryAdminDto,
	IUnitDetailsDto,
	IUnitDetailsOptimizationAccessDto,
	SelectedLanguage,
	SubscriptionInfoImportClient,
	TemporarySubscriptionStartDto,
	UnitDetailsAdditionalRequirementsDto,
	UnitDetailsAdminDto,
	UnitDetailsClient,
	UnitDetailsCountryAdminDto,
	UnitDetailsOptimizationAccessDto,
} from 'api/api';
import { Action, Dispatch } from 'redux';
import { AsyncOperationBuilder, AsyncOperationBuilderWithoutState } from 'utilities/api-helper';
import { baleStorageClient, subscriptionInfoImportClient, unitDetailsClient } from '../api-clients';
import {
	GetDropdownOptions,
	GetMachineDetailsAction,
	UpsertMachineDetailsAdminAction,
	UpsertMachineDetailsCountryAdminAction,
	UpsertMachineDetailsOptimizationAccessAction,
	UpsertMachineDetailsServiceTechnicianOrAdminAction,
	setTemporarySubscription,
	UpdateIsFavouriteAction,
	UpdateUnitOwnerGroupAction,
	UpsertBaleStorageAction,
} from './actions';

export async function getMachineDetails(serialNumber: string) {
	return AsyncOperationBuilder(
		GetMachineDetailsAction,
		apiClient => (apiClient as UnitDetailsClient).get(serialNumber),
		{ serialNumber },
		unitDetailsClient
	);
}

export async function getMachineDetailsWithoutState(serialNumber: string) {
	return AsyncOperationBuilderWithoutState(
		apiClient => (apiClient as UnitDetailsClient).get(serialNumber),
		unitDetailsClient
	);
}

export async function getUnitDetails(serialNumber: string, language: SelectedLanguage) {
	return AsyncOperationBuilder(
		GetMachineDetailsAction,
		apiClient => (apiClient as UnitDetailsClient).getByLanguage(serialNumber, language),
		{ serialNumber },
		unitDetailsClient
	);
}

export async function getDropDownOptions() {
	return AsyncOperationBuilder(
		GetDropdownOptions,
		apiClient => (apiClient as UnitDetailsClient).getDropDownData(),
		{},
		unitDetailsClient
	);
}

export async function updateUnitOwnerGroup(unitId: number, ownerGroupId: number) {
	return AsyncOperationBuilder(
		UpdateUnitOwnerGroupAction,
		apiClient => (apiClient as UnitDetailsClient).updateUnitOwnerGroup(unitId, ownerGroupId),
		{ unitId, ownerGroupId },
		unitDetailsClient
	);
}

export async function upsertMachineDetailsCountryAdmin(machineDetailsDto: IUnitDetailsCountryAdminDto) {
	return AsyncOperationBuilder(
		UpsertMachineDetailsCountryAdminAction,
		apiClient => (apiClient as UnitDetailsClient).putCountryAdmin(machineDetailsDto as UnitDetailsCountryAdminDto),
		machineDetailsDto,
		unitDetailsClient
	);
}

export async function upsertMachineDetailsAdmin(
	machineDetailsDto: IUnitDetailsAdminDto,
	updateCoordinates: boolean = false
) {
	return AsyncOperationBuilder(
		UpsertMachineDetailsAdminAction,
		apiClient =>
			(apiClient as UnitDetailsClient).putAdmin(machineDetailsDto as UnitDetailsAdminDto, updateCoordinates),
		machineDetailsDto,
		unitDetailsClient
	);
}

export async function upsertMachineDetailsServiceTechnicianOrAdmin(
	machineDetailsDto: IUnitDetailsAdditionalRequirementsDto
) {
	return AsyncOperationBuilder(
		UpsertMachineDetailsServiceTechnicianOrAdminAction,
		apiClient =>
			(apiClient as UnitDetailsClient).putServiceTechnicianOrAdmin(
				machineDetailsDto as UnitDetailsAdditionalRequirementsDto
			),
		machineDetailsDto,
		unitDetailsClient
	);
}

export async function upsertMachineDetailsOptimizationAccess(machineDetailsDto: IUnitDetailsOptimizationAccessDto) {
	return AsyncOperationBuilder(
		UpsertMachineDetailsOptimizationAccessAction,
		apiClient =>
			(apiClient as UnitDetailsClient).putOptimizationAccess(
				machineDetailsDto as UnitDetailsOptimizationAccessDto
			),
		machineDetailsDto,
		unitDetailsClient
	);
}

//Baler functions
export function UpsertBaleStorage(baleStorageInput: IBaleStorageDto, addNew: boolean) {
	const baleStorage = new BaleStorageDto();
	baleStorage.init(baleStorageInput);

	if (addNew)
		return AsyncOperationBuilder(
			UpsertBaleStorageAction,
			apiClient => (apiClient as BaleStorageClient).createBaleStorage(baleStorage),
			baleStorageInput,
			baleStorageClient
		);
	else
		return AsyncOperationBuilder(
			UpsertBaleStorageAction,
			apiClient => (apiClient as BaleStorageClient).updateBaleStorage(baleStorage),
			baleStorageInput,
			baleStorageClient
		);
}
export const UpdateIsFavourite = (unitDetails: IUnitDetailsDto, isFavourite: boolean) => {
	return (dispatch: Dispatch<Action<{}>>) => {
		if (!unitDetails.unitId) return;
		dispatch(UpdateIsFavouriteAction({ unitId: unitDetails.unitId, isFavourite }));
	};
};

export function SetTemporarySubscription(startDto: TemporarySubscriptionStartDto) {
	return AsyncOperationBuilder(
		setTemporarySubscription,
		apiClient => (apiClient as SubscriptionInfoImportClient).setTemporarySubscription(startDto),
		startDto,
		subscriptionInfoImportClient
	);
}
